import axios, { type AxiosInstance } from 'axios';
const axiosApiClient: AxiosInstance = axios.create({
  baseURL: import.meta.env.VITE_API_SERVER,
  withCredentials: true, // Include credentials in requests (e.g., cookies)
  withXSRFToken: true, // Include XSRF token in requests
});

axiosApiClient.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    //debugger;
    // Handle response error
    if (error.status === 401) {
      // Handle unauthorized access (e.g., redirect to login page)
      //clear local storage
      localStorage.removeItem('user');
      localStorage.removeItem('token');
      localStorage.removeItem('calculatorCart');
      // debugger;
      // router.push({ name: 'home' });
      window.location.href = '/';
    }
    //throw error; // Rethrow the error to be handled by the calling code
  },
);
export default axiosApiClient;
